<template>
  <b-modal
    id="race-config"
    hide-header
    centered
    size="sm"
    cancel-variant="outline-secondary"
    hide-footer
    @show="handleGetDataRaceConfig"
  >
    <div style="color: #000; padding: 20px">
      <div
        class="d-flex flex-column justify-content-between align-items-center text-center"
      >
        <p class="mb-1" style="font-size: 25px; font-weight: 800">
          CONFIG RACE TIME
        </p>
      </div>
      <div class="mt-2">
        <p class="font-weight-bold">
          Close Race After (s)
          <small style="font-weight: 400"
            >(Current value: {{ originData ? originData.openBetBufferSeconds : 0 }}s)</small
          >
        </p>
        <b-form-input
          v-model="data.openBetBufferSeconds"
          placeholder="Enter second number..."
        />
      </div>
      <div class="mt-1">
        <p class="font-weight-bold">
          Reopen Race for (s)
          <small style="font-weight: 400"
            >(Current value: {{ originData ? originData.reopenBetBufferSeconds : 0 }}s)</small
          >
        </p>
        <b-form-input
          v-model="data.reopenBetBufferSeconds"
          placeholder="Enter second number..."
        />
      </div>

      <div class="mt-2 d-flex justify-content-end">
        <b-button @click="closeModal" class="w-100">CANCEL</b-button>
        <b-button
          @click="handleApplyNewValue"
          :disabled="loadingRaceConfig"
          variant="success"
          class="ml-2 font-weight-bold w-100 text-nowrap"
        >
          <Spinner v-if="loadingRaceConfig" />
          <template v-else> APPLY NEW VALUE </template>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Spinner from "@/@core/components/Spinner.vue";
import { BButton, BModal, BFormGroup, BFormInput } from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    BButton,
    BModal,
    BFormGroup,
    BFormInput,
    Spinner,
  },
  data() {
    return {
      data: {
        openBetBufferSeconds: null,
        reopenBetBufferSeconds: null,
      },
      originData: null,
    };
  },
  computed: {
    ...mapState("trading/config", ["loadingRaceConfig"]),
  },
  methods: {
    ...mapActions({
      updateDataRaceConfig: "trading/config/updateDataRaceConfig",
      getDataRaceConfig: "trading/config/getDataRaceConfig",
    }),
    async handleGetDataRaceConfig() {
      const res = await this.getDataRaceConfig();
      if (res.value) {
        this.originData = res.value;
        this.data.openBetBufferSeconds = res.value.openBetBufferSeconds;
        this.data.reopenBetBufferSeconds = res.value.reopenBetBufferSeconds;
      }
    },
    closeModal() {
      this.$bvModal.hide("race-config");
    },
    handleCloseModal() {
      this.$bvModal.hide("race-config");
      this.data.openBetBufferSeconds = null;
      this.data.reopenBetBufferSeconds = null;
      this.originData = null;
    },
    async handleApplyNewValue() {
      const res = await this.updateDataRaceConfig({
        key: "race-config",
        value: {
          openBetBufferSeconds: Number(this.data.openBetBufferSeconds),
          reopenBetBufferSeconds: Number(this.data.reopenBetBufferSeconds),
        },
      });

      if (res) {
        this.$toast.success("Data updated successfully");
        this.handleCloseModal();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dollar-icon {
  background: #e6f9ed;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
</style>
